import { ConsoleColor, logData } from '../../utils/console.js';
export const getMimir = () => {
    if (!('mimir' in window)) {
        return undefined;
    }
    return window.mimir;
};
export const configureMimir = (options) => {
    const mimir = getMimir();
    if (!mimir) {
        return;
    }
    mimir.config({
        session_id: options.sessionId,
        user_properties: options.userProperties,
    });
};
export const trackEvent = (event) => {
    const mimir = getMimir();
    if (!mimir) {
        return;
    }
    mimir.event(event.name, event.params);
    logData('Event sent (Mimir)', event.name, event, ConsoleColor.EVENT);
};
//# sourceMappingURL=mimir.js.map